module.exports = __webpack_public_path__ + "static/media/clue-2.7efc1571.svg";